'use es6';

import { configure } from 'reporting-data/configure';
import configureFilters from 'reporting-data/configure/filters';
import { getConfigs } from 'reporting-data/report/multiConfigReportGetters';
export const fixFilters = report => {
  const primaryConfig = report.get('config');
  const otherConfigs = getConfigs(report).valueSeq();
  const configKeys = getConfigs(report).keySeq();
  return Promise.all([primaryConfig, ...otherConfigs].map(configureFilters)).then(configuredConfigs => {
    const primary = configuredConfigs.shift();
    return configuredConfigs.reduce((configuredReport, config, index) => {
      return configuredReport.setIn(['reportConfigs', configKeys.get(index)], config);
    }, report.set('config', primary));
  });
};
export default (report => configure(report.get('config')).then(configured => report.set('config', configured)));